import React from 'react'
import { ContainerContent, ContainerTemplate } from '../../components/Containers'
import { Header } from '../../components/Header'
import { Icon } from '../../components/Icon'
import { Title } from '../../components/Title'

export const TemplatePage404: React.FC = () => {
  return (
    <ContainerTemplate>
      <Header text="404" />
      <ContainerContent style={{ justifyContent: 'center' }}>
        <Title text="Opa... Nenhuma página foi encontrada!" />
        <Icon text="Ícone de error" path="/images/icons/iconError.svg" />
      </ContainerContent>
    </ContainerTemplate>
  )
}
